<template>
    <LoopingRhombusesSpinner
        :animation-duration="props.animationDuration"
        :rhombus-size="props.rhombusSize"
        :color="props.color"
        :class="props.class" />
</template>

<script setup>
import { LoopingRhombusesSpinner } from 'epic-spinners';

const props = defineProps({
    animationDuration: { type: Number, default: 2500 },
    rhombusSize: { type: Number, default: 7 },
    dotsNum: { type: Number, default: 3 },
    color: { type: String, default: '#00c951' },
    class: { type: null, required: false }
});
</script>
